module.exports = __webpack_public_path__ + "static/img/edge.a92a124b.png";